export default __webpack_public_path__ + "static/media/lookup.8243bb39.svg";